module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "show": _vm.showEditPrinterModal,
      "effect": "fade"
    },
    on: {
      "closeOnEscape": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "modal-header center",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title center"
  }, [_vm._v("Edit Printer")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": !_vm.$root.permissions['printers update']
    }
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerToBeEdited.printer_name),
      expression: "printerToBeEdited.printer_name"
    }],
    staticClass: "form-control input-sm edited",
    attrs: {
      "type": "text",
      "id": "form_control_1"
    },
    domProps: {
      "value": (_vm.printerToBeEdited.printer_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerToBeEdited, "printer_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_1"
    }
  }, [_vm._v("Printer Name")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerToBeEdited.printer_key),
      expression: "printerToBeEdited.printer_key"
    }],
    staticClass: "form-control input-sm edited",
    attrs: {
      "type": "text",
      "id": "form_control_2"
    },
    domProps: {
      "value": (_vm.printerToBeEdited.printer_key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerToBeEdited, "printer_key", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_2"
    }
  }, [_vm._v("Printer Key")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerToBeEdited.printer_serialno),
      expression: "printerToBeEdited.printer_serialno"
    }],
    staticClass: "form-control input-sm edited",
    attrs: {
      "type": "text",
      "id": "form_control_3"
    },
    domProps: {
      "value": (_vm.printerToBeEdited.printer_serialno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerToBeEdited, "printer_serialno", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_3"
    }
  }, [_vm._v("Printer Serial Number")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerToBeEdited.copies),
      expression: "printerToBeEdited.copies"
    }],
    staticClass: "form-control input-sm edited",
    attrs: {
      "type": "text",
      "id": "form_control_4"
    },
    domProps: {
      "value": (_vm.printerToBeEdited.copies)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerToBeEdited, "copies", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_4"
    }
  }, [_vm._v("Copies")])])]), _vm._v(" "), _c('div', {
    staticClass: "side-by-side-wrapper"
  }, [_c('p', {
    staticClass: "paper-width-label"
  }, [_vm._v("Paper width:")]), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "size": "mini",
      "show-timeout": 50,
      "hide-timeout": 50
    },
    on: {
      "command": _vm.updatePrinterToBeEditedPaperWidth
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.printerToBeEdited.paper_width) + "mm\n\t\t\t\t\t"), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "58"
    }
  }, [_vm._v("58mm")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "80"
    }
  }, [_vm._v("80mm")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "side-by-side-wrapper"
  }, [_c('p', {
    staticClass: "side-by-side-item status-label"
  }, [_vm._v("Status:")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "disabled": !_vm.$root.permissions['printers update'],
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Enabled",
      "inactive-text": "Disabled"
    },
    model: {
      value: (_vm.printerToBeEdited.status),
      callback: function($$v) {
        _vm.$set(_vm.printerToBeEdited, "status", $$v)
      },
      expression: "printerToBeEdited.status"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(!_vm.$root.permissions['printers update']) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_vm._v("\n\t\t\tClose\n\t\t")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.updatePrinter()
      }
    }
  }, [_vm._v("\n\t\t\tSave\n\t\t")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54ea261a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/Printers/EditPrinter.vue
// module id = 724
// module chunks = 0